import React, {FC} from 'react';

import s from './cartItemPlaceholder.scss';

/**
 * Cart Item Placeholder for checkout page
 *
 * @constructor
 */
export const CartItemPlaceholder: FC = () => (
    <div className={s.wrapper}>
        <div className={s.carrier}>
            <div className={s.image} />
            <div className={s.rowWrapper}>
                <div className={s.row} />
                <div className={s.row} />
                <div className={s.row} />
                <div className={s.row} />
            </div>
        </div>
        <div className={s.row} />
        <div className={s.row} />
        <div className={s.row} />
    </div>
);
